import React from "react";
import style from "./FilterOut.css";

export const FilterOut = () => (
  <div data-auto-id="filterOutMessage" className={style.wrapper} />
);

FilterOut.propTypes = {};

FilterOut.displayName = "FilterOut";

export default FilterOut;
